module.exports = __webpack_public_path__ + "img/3.c44c4628.jpg";